import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'alt_summary';
export const route = 'alt_summary/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "alt_summary" */
/* webpackPrefetch: true */
'../components/AltSummaryPage')));